import styled from "styled-components";
import { zIndex } from "styles";

export const ModalStyles = styled.div`
  padding: 32px;
  width: 500px;
  border-radius: 10px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: ${({ theme }) => theme.colors.white};
  z-index: ${zIndex.modal};
  font-family: ${({ theme }) => theme.fonts.primary};
`;
export const OverlayStyles = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.colors.transparent["black70"]};
  z-index: ${zIndex.modal};
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;
